import React, { useState } from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row, Col, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import "react-datetime/css/react-datetime.css";
import Select from 'react-select';


export const FormGlobalComment = ({
    toggleCrudComment, 
    handleInputChange, saveCreate, text
    
}) => {


    return (
        <Form className="" role="form" onSubmit={saveCreate}>
                <FormGroup>
                    <Label className="label-admision">
                        Texto <span className='f-16' style={{ color: "#0079C7" }}>*</span>
                    </Label>
                    <Input
                        name='text'
                        type="text"
                        value={text}
                        required={true}
                        onChange={handleInputChange}
                        className="input-admision"
                    />
                    <FormFeedback>Debes llenar este campo</FormFeedback>
                    
                </FormGroup>
            <ModalFooter>
            <Button
                    size="sm"
                    className="btn-air-light"
                    color="primary"
                    type="submit"
                >
                    Guardar
                </Button>
                <Button
                    size="sm"
                    className="btn-air-light"
                    color="danger"
                    type="button"
                    onClick={toggleCrudComment}
                >
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    );
};

